
<template>
  <!-- Funcionando ok.. Implementar destruição dos objetos em vuex -->

  <div>
    <v-dialog v-model="dialog" width="500" persistent scrollable>
      <v-card style="border-radius:9px">
        <v-card-title class="pa-0">
          <v-toolbar
            color="primary"
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left>mdi-soccer</v-icon>Marcar gols
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="dialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="teamsTabs" grow>
            <v-tab v-for="(title, index) in [homeTeam, awayTeam]" :key="index">{{title.team_name}}</v-tab>
            <v-tabs-items v-model="teamsTabs">
              <v-tab-item v-for="(team, index) in [homeTeam, awayTeam]" :key="index">
                <template>
                  <v-data-table
                    :headers="headers"
                    :items="available_squad_numbers(team.squads)"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        <div class="icon-stack">
                          <v-icon
                            large
                            :color="index<1? 'primary': 'blue-grey darken-1'"
                            class="icon-stack-1x"
                          >fa-tshirt</v-icon>
                          <span
                            class="white--text icon-stack-3x font-weight-bold"
                          >{{ props.item.shirt }}</span>
                        </div>
                      </td>
                      <!-- <td class="text-xs-center">{{ props.item.name }}</td> -->
                      <td class="text-xs-center">
                        <v-layout row wrap justify-center align-center>
                          <v-btn
                            small
                            flat
                            icon
                            color="red"
                            @click.stop="props.item.auxGoals--"
                            :disabled="props.item.auxGoals==0"
                          >
                            <v-icon>remove</v-icon>
                          </v-btn>
                          {{props.item.auxGoals}}
                          <v-btn small flat icon color="green" @click.stop="props.item.auxGoals++">
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-layout>
                      </td>
                    </template>
                    <template>
                      <td class="text-xs-center">
                        <div class="icon-stack">
                          <v-icon
                            large
                            :color="index<1? 'primary': 'blue-grey darken-1'"
                            class="icon-stack-1x"
                          >fa-tshirt</v-icon>
                          <span class="white--text icon-stack-3x font-weight-bold">C</span>
                        </div>
                      </td>
                    </template>
                    <v-alert type="warning" slot="no-data" :value="true">Escale jogadores</v-alert>
                  </v-data-table>

                  <!-- GOL CONTRA -->
                  <v-layout row wrap justify-center align-center class="mt-2">
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click.stop="delOwnGoal(index)"
                      :disabled="ownGoals[index]==0"
                    >
                      <v-icon>remove</v-icon>
                    </v-btn>
                    Gol contra do adversário: {{ownGoals[index]}}
                    <v-btn flat icon color="green" @click="addOwnGoal(index)">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-layout>
                </template>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
        <v-layout justify-center align-center>
          <v-toolbar-title>{{scoreA}} x {{scoreB}}</v-toolbar-title>
        </v-layout>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn block color="primary" @click="dialog=false, submitGoals()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn block @click="dialog=true" color="primary">
          <v-icon left dark color="white">mdi-soccer</v-icon>Marcar Gols
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      teamsTabs: 0,
      headers: [
        { text: "Núm.", align: "center", value: "number" },
        // { text: 'Nome', align: 'center', value: 'name'},
        { text: "Gols", align: "center", value: "goals", sortable: false }
      ],
      ownGoals: [0, 0]
    };
  },
  methods: {
    addOwnGoal(i) {
      this.$set(this.ownGoals, i, this.ownGoals[i] + 1);
    },
    delOwnGoal(i) {
      this.$set(this.ownGoals, i, this.ownGoals[i] - 1);
    },
    submitGoals() {
      var goalPapers = [];
      this.homeTeam.squads.forEach(element => {
        for (var i = 0; i < element.auxGoals; i++) {
          const paper = {};
          paper.event_time = null;
          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = element.squad_number_id;
          paper.shirt = element.shirt;
          paper.player = element.player_name;
          paper.champ_team_id = this.homeTeam.id;
          paper.kind = "gol";
          goalPapers.push(paper);
        }
      });
      this.awayTeam.squads.forEach(element => {
        for (var i = 0; i < element.auxGoals; i++) {
          const paper = {};
          paper.event_time = null;

          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = element.squad_number_id;
          paper.shirt = element.shirt;
          paper.player = element.player_name;
          paper.champ_team_id = this.awayTeam.id;
          paper.kind = "gol";
          goalPapers.push(paper);
        }
      });

      for (var j = 0; j < this.ownGoals[0]; j++) {
        const paper = {};
        paper.event_time = null;
        paper.match_id = this.oneMatch.data.id;
        paper.squad_number_id = null;
        paper.champ_team_id = this.homeTeam.id;
        // paper.player = "gol contra!";

        paper.kind = "gol contra"; //Soma com gol pro
        goalPapers.push(paper);
      }
      for (var j = 0; j < this.ownGoals[1]; j++) {
        const paper = {};
        paper.event_time = null;
        paper.match_id = this.oneMatch.data.id;
        paper.squad_number_id = null;
        paper.champ_team_id = this.awayTeam.id;
        // paper.player = "gol contra!";
        paper.kind = "gol contra"; //Soma com gol pro
        goalPapers.push(paper);
      }

      this.setGoalPapers(goalPapers);
    },
    available_squad_numbers(squad) {
      return squad.filter(obj => obj.shirt > 0);
    },
    ...mapMutations({
      setGoalPapers: "Match/setGoalPapers"
    })
  },
  computed: {
    scoreA() {
      return (
        this.homeTeam.squads.reduce((prev, cur) => prev + cur.auxGoals, 0) +
        this.ownGoals[0]
      );
    },
    scoreB() {
      return (
        this.awayTeam.squads.reduce((prev, cur) => prev + cur.auxGoals, 0) +
        this.ownGoals[1]
      );
    },

    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    }),
    ...mapState({
      oneMatch: state => state.Match.oneMatch,
      goalPapers: state => state.Match.goalPapers
    })
  },

  created() {},

  watch: {
    dialog(nv, ov) {
      //IMPROVISANDO PARA NAO LIMPAR EVENTOS AO ATUALIZAR A ESCALACAO
      if (nv) {
        this.homeTeam.squads.forEach(element => {
          element.auxGoals = 0;
        });
        this.awayTeam.squads.forEach(element => {
          element.auxGoals = 0;
        });
        this.goalPapers.forEach(goal => {
          if (goal.squad_number_id) {
            let homePlayer = this.homeTeam.squads.find(function(squad) {
              return squad.squad_number_id === goal.squad_number_id;
            });
            if (homePlayer) homePlayer.auxGoals++;
            let awayPlayer = this.awayTeam.squads.find(function(squad) {
              return squad.squad_number_id === goal.squad_number_id;
            });
            if (awayPlayer) awayPlayer.auxGoals++;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
.icon-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.icon-stack-1x,
.icon-stack-3x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.icon-stack-1x {
  line-height: inherit;
}
</style>